import Base from './base'

export default class CrmSync extends Base {
  get() {
    return this.api.get(`teams/crm_sync_settings.json`)
  }
  getCRMConnection() {
    return this.api.get('crm_connection.json')
  }
}
